import camelcaseKeys from 'camelcase-keys'
import {WebappUser} from '@/entities/webapp-user/WebappUser' 
import {WebappUserCredential} from '@/entities/webapp-user/WebappUserCredentials'

export class Settings {
  constructor (params = {}) {
    const { webappUser, webappUserCredentials } = camelcaseKeys(params)
    this.webappUser = webappUser ? new WebappUser(webappUser) : {}
    this.webappUserCredentials = webappUserCredentials ? webappUserCredentials.map((e) => new WebappUserCredential(e)) : []

  }
}

